import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';

@Component({
    selector: 'dbm-file-upload',
    template: require('./dbm-file-upload.component.html'),
    styles: [require('./dbm-file-upload.component.scss')]
})
export class DbmFileUploadComponent implements OnInit{
    @Input() public allowedFilesTypes;
    @Input() public fromScriptDialog = false;
    @Input() public maxUploadingFileCount: number = 20;
    @Output() public processFiles: EventEmitter<any> = new EventEmitter();

    public multiply = '';

    public uploadDone: boolean = false;
    public errors: any[] = [];
    public translations: any = [];
    public files: any = [];
    private regexFile: RegExp;

    // Build the file input's `accept` attribute by dot-prefixing every extension,
    // so a bare list like "sql,zip,rar,tar" becomes ".sql,.zip,.rar,.tar".
    public get acceptAttr(): string {
        if (!this.allowedFilesTypes) { return ''; }
        return this.allowedFilesTypes
            .split(',')
            .map((ext: string) => '.' + ext.trim().replace(/^\.+/, ''))
            .join(',');
    }
    constructor(private translatePipe: TranslatePipe) {
    }

    public async ngOnInit() {
        await this.translatePipe.transform(['ERROR_PATTERN_FILE',
            'ERROR_MAX_SIZE_FILE', 'ERROR_MAX_FILEs',
            'ERROR_PATTERN_FILE']).then(value => this.translations = value);
        this.regexFile = new RegExp(`(.*?)\.(${this.allowedFilesTypes.split(',').join('|')})$`);
    }

    public uploadFiles(files): void {
        this.fileValidation(files);
        if (this.errors.length !== 0) {
            this.files = [];
            this.uploadDone = false;
            return;
        }
         this.files = files;
        if (files && files.length) {
            this.processFiles.emit(files);
            for (let i = 0; i < files.length; i++) {
                files[i].progress = 100;
            }
            this.uploadDone = true;
        }
    }

    public fileValidation(files): void {
        this.errors = [];
        if (files.length > this.maxUploadingFileCount) {
            this.errors.push(this.translations['ERROR_MAX_FILEs'].replace('[FILE_COUNT]', this.maxUploadingFileCount));
            return;
        }
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (!(this.regexFile.test(file.name))) {
                const message = this.translations['ERROR_PATTERN_FILE'].replace('[File]', file.name)
                    .replace('FILES_PATTERN', this.allowedFilesTypes);
                this.errors.push(message);
                return;
            }
            if (file.size > 20971520) {
                const message = this.translations['ERROR_MAX_SIZE_FILE'].replace('[File]', file.name);
                this.errors.push(message);
                return;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-file-upload/dbm-file-upload.component.ts